<template>
    <div class="wrapper">
        <div class="topo-header centro">
            <botao-voltar nomeRota="Status" />
            <h1>{{ statusForm.id ? "Editar" : "Novo" }} Status</h1>
        </div>
        <div class="tab-dados-basicos">
            <div class="form centro">
                <MsgErroFormularios v-if="erro && msgErros" :mensagens="msgErros" :erro="erro" @fechar-erro="fecharErro"/>
                <p>Os campos com asterisco (*) são de preenchimento obrigatório.</p>                
                <form @submit.prevent="enviarForm">
                    <div class="caixa-form item">
                        <div class="flexbox-3">
                            <div class="item">
                                <label><b>{{ possuiAsterisco("Nome:") }}</b></label>
                                <input type="text" placeholder="Digite o nome" v-model="statusForm.nome" />
                            </div>
                            <div class="item">
                                <label><b>{{ possuiAsterisco("Código:") }}</b></label>
                                <input type="number" min="0" max="9" v-model="statusForm.codigo" @input="inRange(statusForm.codigo)"/>
                                <p id="mensagem" class="mensagem"> Apenas 0 até 9 são permitidos! </p>
                            </div>
                            <div class="item">
                                <div class="radio">
                                    <label class="radio-label"><b>{{ possuiAsterisco("Ativo:") }}</b></label>
                                    <div class="radio-buttons">
                                        <div class="radio-item">
                                            <label for="origem-status">Sim</label>
                                            <input type="radio" id="origem-status"
                                                :value=true v-model="statusForm.ativo">
                                        </div>
                                        <div class="radio-item">
                                            <label for="destino-status">Não</label>
                                            <input type="radio" id="destino-status"
                                                :value=false v-model="statusForm.ativo">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="bt-salvar">
                            <button id="botao-salvar" title="Criar/Atualizar" type="submit">
                                <img id="spinner-loading" class="spinner-loading"
                                    src="../../assets/imagens/loadingSpinner.gif" alt="Spinner de carregamento">
                                <p id="conteudo-botao">{{ statusForm.id ? "Atualizar" : "Criar" }}</p>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script lang="js">
    import StatusApi from "../../services/StatusApi";
    import BotaoVoltar from "../../components/BotaoVoltar.vue";
    import MsgErroFormularios from "../MsgErroFormularios";

    export default {
        name: "StatusForm",
        props: {
            status: {
                type: Object,
                required: false,
            },
        },
        data() {
            return {
                count: -1,
                count1: null,
                filess: null,
                carregando: true,
                erro: false,
                msgErros: {
                    nome: '',
                    ativo: '',
                    codigo: '',
                },
                statusForm: this.status
                    ? {
                        id: this.status.id,
                        nome: this.status.nome,
                        codigo: this.status.codigo,
                        ativo: this.status.ativo
                    }
                    : {
                        id: null,
                        nome: null,
                        codigo: null,
                        ativo: null,
                    },
            };
        },
        components: {
            BotaoVoltar,
            MsgErroFormularios,
        },
        created() {
            this.statusApi = new StatusApi();
        },
        methods: {
            fecharErro() {
                this.erro = false;
            },
            inRange(codigo) {
                let divMensagem = document.getElementById("mensagem");

                if (codigo > 9 || codigo <= 0) {
                    divMensagem.style.display = "block"
                }

                if (codigo <= 9 && codigo >= 0) {
                    divMensagem.style.display = "none"
                }

                if(codigo == '') {
                    divMensagem.style.display = "none"
                }
            },
            mudarBotaoSalvar(textoBotao) {
                let botaoSalvar = document.getElementById("botao-salvar");
                let conteudoBotao = document.getElementById("conteudo-botao");
                let spinnerLoading = document.getElementById("spinner-loading");

                let novoTextoConteudoBotao = "Carregando"

                //mudar para o carregando
                botaoSalvar.disabled = true;
                botaoSalvar.style.backgroundColor = "gray"
                conteudoBotao.innerHTML = novoTextoConteudoBotao;
                conteudoBotao.style.display = "inline-block"
                spinnerLoading.style.visibility = "visible"
                spinnerLoading.style.position = "relative"

                if (this.erro == true) {
                    //mudar para o padrão (da aba dados básicos)
                    botaoSalvar.disabled = false;
                    botaoSalvar.style.backgroundColor = "#005516"
                    conteudoBotao.innerHTML = textoBotao;
                    spinnerLoading.style.visibility = "hidden"
                    spinnerLoading.style.position = "absolute"
                }
            },
            async enviarForm() {
                let conteudoBotao = document.getElementById("conteudo-botao");
                const textoConteudoBotao = conteudoBotao.innerHTML;
                
                let flag = this.validarForm(this.statusForm);

                if (flag == 1) {
                    this.erro = true;
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                    return false
                }

                this.statusForm.codigo = parseInt(this.statusForm.codigo, 10)
                
                try {
                    this.carregando = true;
                    this.erro = false;
                    this.msgErros = '';

                    this.mudarBotaoSalvar(textoConteudoBotao);

                    if (this.statusApi.cancelTokens.setStatus) {
                        this.statusApi.cancelTokens.setStatus.cancel();
                    }

                    let data;
                    data = await this.statusApi.setStatus(
                        this.statusForm
                    );

                    var rota = this.$router;
                    setTimeout(function () {
                        rota.push({
                            name: "StatusShow",
                            params: {
                                id: data.id,
                            },
                        });
                    }, 1000);
                    //window.location.reload();
                } catch (err) {
                    if (this.statusApi.isCancel(err)) {
                        return;
                    }
                    console.log(err);
                    this.carregando = false;
                    this.erro = true;

                    this.mudarBotaoSalvar(textoConteudoBotao)

                    const { response } = err;
                    if (response && response.data) {
                        this.msgErros = response.data;
                    } else {
                        this.msgErros =
                            "Houve um erro ao salvar o registro. Por favor tente novamente.";
                    }
                }
            },
            validarForm(statusForm) {
                let flag = 0;

                //Resetar as mensagens de erro
                this.msgErros.nome = ''
                this.msgErros.ativo = ''
                this.msgErros.codigo = ''
                this.msgErros.default = ''

                if(statusForm.nome == null || statusForm.nome == ''){
                    this.msgErros.nome = "O campo Nome não foi preenchido.";
                    flag = 1;
                }
                
                if(statusForm.ativo == null){
                    this.msgErros.ativo = "O campo Ativo não foi preenchido.";
                    flag = 1;
                } 

                if (statusForm.codigo == null) {
                    this.msgErros.codigo = "O campo Código não foi preenchido.";
                    flag = 1;
                }

                return flag;
            },
            possuiAsterisco(texto) {
                var texto_final = "* " + texto
                return texto_final
            },
        },

    };
</script>

<style lang="scss">
    .mensagem {
        display: none;
        color: red;
        font-size: .85rem;
    }

    @media screen and (min-width: "1066px") {
        .caixa-form {
            .flexbox-1 {
                display: grid;
                grid-template-columns: 1fr .5fr 2fr;
                gap: 2rem;
            }

            .flexbox-2 {
                display: flex;
                justify-content: space-between;
                gap: 2rem;
            }

            .flexbox-3 {
                display: grid;
                grid-template: "a b c";
                grid-template-columns: 5fr 1.1fr .3fr;
                gap: 1.5rem;
            }

            .item {
                .radio-buttons {
                    display: flex;
                }
            }
        }
    }
</style>
